module.exports = __webpack_public_path__ + "img/forgot-password-framme-store.37f0f891.png";